var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#4AA215"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3745 12.1622C13.5503 11.3362 12.859 10.5836 12.0212 10.6886L11.3343 10.7747C11.2284 10.788 11.1424 10.8667 11.1198 10.9711C11.0899 11.1097 11.1805 11.2456 11.32 11.2714L11.5714 11.3177C11.9022 11.3965 11.9674 11.5157 11.8954 11.8454L11.0652 15.7469C10.8469 16.756 11.1833 17.2307 11.9742 17.2307C12.5728 17.2307 13.2659 16.9605 13.5988 16.5854C13.6146 16.5676 13.6249 16.5458 13.6298 16.5226C13.659 16.3845 13.4706 16.2577 13.3364 16.3015C13.1977 16.3467 13.0596 16.3667 12.9496 16.3667C12.6402 16.3667 12.5277 16.1496 12.6076 15.7671L13.3745 12.1622ZM13.8124 8.125C13.8124 8.42337 13.6939 8.70952 13.4829 8.92049C13.272 9.13147 12.9858 9.25 12.6874 9.25C12.3891 9.25 12.1029 9.13147 11.892 8.92049C11.681 8.70952 11.5624 8.42337 11.5624 8.125C11.5624 7.82663 11.681 7.54048 11.892 7.3295C12.1029 7.11853 12.3891 7 12.6874 7C12.9858 7 13.272 7.11853 13.4829 7.3295C13.6939 7.54048 13.8124 7.82663 13.8124 8.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccessIcon);
export default __webpack_public_path__ + "static/media/toast_success_icon.2a7bd1494235a51df4f43f80f06dfc72.svg";
export { ForwardRef as ReactComponent };